import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConsoleApplicationService} from '../../../services/console-application.service';
import {FormBuilder, FormControl, FormControlName, FormGroup, Validators, ValidatorFn, FormArray} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import {permissions} from '../../../permissions';
import {GenericValidator} from '../../../shared/generic-validator';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-console-application-edit',
    templateUrl: './console-applications-edit.component.html',
    styleUrls: ['./console-applications-edit.component.scss'],
    providers: [
    ]
})
export class ConsoleApplicationsEditComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    protected form;
    public model: any;
    protected errors: any = {};
    public loading = false;
    public commandActions: string[][];
    protected displayMessage: { [key: string]: string } = {};
    protected serverErrors;
    protected errorMessage: string;
    protected genericValidator: GenericValidator;
    protected validationMessages: { [key: string]: { [key: string]: string } };
    public  permissions = permissions;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private consoleApplicationService: ConsoleApplicationService,
        private title: Title
    ) {
        this.consoleApplicationService.getCommandActions().subscribe(result => {
            this.commandActions = JSON.parse(result);
        });
        this.validationMessages = {
            CL1_NAME: {
                required: 'Console Application name is required.',
            },
            CL1_INTERVAL_MINUTES: {
                required: 'Interval is required.',
            },
            commandAction: {
                required: 'Command and Action are required.',
            },
            CL1_DESCRIPTION: {}
        };
        this.genericValidator = new GenericValidator(this.validationMessages);
        this.title.setTitle('Admin - Console Applications');
    }

    ngOnInit(): void {

        const consoleApplicationId = this.route.snapshot.params.id;
        this.consoleApplicationService.getById(consoleApplicationId).subscribe( consoleApplication => {
            this.model = consoleApplication;
            this.model.commandAction = JSON.stringify([this.model.CL1_COMMAND,this.model.CL1_FUNCTION]);
            this.form = new FormGroup({
                CL1_ID: new FormControl({ value: this.model.CL1_ID, disabled: true }),
                CL1_ENABLED: new FormControl(this.model.CL1_ENABLED),
                CL1_NAME: new FormControl(this.model.CL1_NAME, [
                    Validators.required,
                    Validators.maxLength(255),
                ]),
                CL1_INTERVAL_MINUTES: new FormControl(this.model.CL1_INTERVAL_MINUTES, [
                    Validators.required,
                    Validators.min(0),
                ]),
                CL1_LAST_RUN: new FormControl(this.model.CL1_LAST_RUN),
                CL1_LAST_RUN_COMPLETE: new FormControl({ value: this.model.CL1_LAST_RUN_COMPLETE, disabled: true }),
                CL1_PID: new FormControl({ value: this.model.CL1_PID, disabled: true }),
                CL1_RUN_STATUS: new FormControl({ value: this.model.CL1_RUN_STATUS, disabled: true }),
                commandAction: new FormControl(this.model.commandAction, Validators.required),
                CL1_DESCRIPTION: new FormControl(this.model.CL1_DESCRIPTION),
                CL1_PARAMS: new FormArray([])
            });
            Object.keys(this.model.CL1_PARAMS).forEach(
                key => this.addParam(key, this.model.CL1_PARAMS[key])
            );

            // Watch for the blur event from any input element on the form.
            const controlBlurs: Observable<any>[] = this.formInputElements
                .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

            // Merge the blur event observable with the valueChanges observable
            Observable.merge(this.form.valueChanges, ...controlBlurs).debounceTime(800).subscribe(value => {
                this.displayMessage = this.genericValidator.processMessages(this.form);
            });


        });

    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }

    addParam(name : string, value : string): void {
        this.form.get('CL1_PARAMS').push(new FormGroup({
            name: new FormControl(name, [
                Validators.required,
                Validators.maxLength(255),
                Validators.pattern("[A-z]+"),
            ]),
            value: new FormControl(value, [
                Validators.required,
                Validators.maxLength(255)
            ])
        }));
    }

    removeParam(paramIndex) {
        this.form.get('CL1_PARAMS').removeAt(paramIndex);
        this.form.markAsDirty();
    }

    getParamsNameByIndex(index) {
        return this.form.get('CL1_PARAMS').controls[index].get('name');
    }

    getParamsValueByIndex(index) {
        return this.form.get('CL1_PARAMS').controls[index].get('value');
    }

    onSubmit(): void {
        if(!this.form.dirty) {
            this.onSubmitComplete();
        } else if (this.form.valid) {
            this.loading = true;
            this.consoleApplicationService.save(this.form.getRawValue(), false)
                .subscribe(
                    data => this.handleSubmitResponse(data)
                );
        }
    }

    handleSubmitResponse(data: any) {
        if(data.errors) {
            this.serverErrors = data.errors;
            this.loading = false;
        } else {
            return this.onSubmitComplete();
        }

    }

    objectKeys(obj) {
        return Object.keys(obj);
    }

    onSubmitComplete(): void {
        // Reset the form to clear the flags
        this.form.reset();
        this.router.navigate(['console-applications']);
    }

    onCancel(): void {
        this.loading = true;
        this.router.navigate(['/console-applications']);
    }

    deleteConsoleApplication(){
        this.loading = true;
        this.consoleApplicationService.delete(this.model.CL1_ID).subscribe(result => {
            this.router.navigate(['console-applications']);
        });
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/console-applications/console-applications-edit/console-applications-edit.component.ts